import { useState } from 'react';
import useWebViewMessages from './useWebViewMessages';

type TapToPayCompatibilityStatus = 'hide_tap_to_pay' | 'update_required_ios';

const useShouldShowTapToPay = (provider?: string) => {
  const [compatibilityStatus, setCompatibilityStatus] = useState<TapToPayCompatibilityStatus>();

  useWebViewMessages<{ status: string }>(message => {
    if (message.status === 'hide_tap_to_pay' || message.status === 'update_required_ios') {
      setCompatibilityStatus(message.status);
    }
  });

  const isIOS = /iPhone/.test(navigator.userAgent);
  const isWebView = !!window.ReactNativeWebView;
  const isStripe = provider === 'stripe';

  return isIOS && isWebView && isStripe && compatibilityStatus !== 'hide_tap_to_pay';
};

export default useShouldShowTapToPay;
